import { defineComponent as i, createElementBlock as o, openBlock as e, mergeProps as u, unref as l, renderSlot as g, createCommentVNode as m, createElementVNode as n } from "vue";
import { useScalarIcon as L } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, H = { key: 1 }, f = { key: 2 }, h = { key: 3 }, A = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconArrowUpRight"
}, M = /* @__PURE__ */ i({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(a) {
    const s = a, { bind: d, weight: r } = L(s);
    return (p, t) => (e(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      g(p.$slots, "default"),
      l(r) === "bold" ? (e(), o("g", V, t[0] || (t[0] = [
        n("path", { d: "M204,64V168a12,12,0,0,1-24,0V93L72.49,200.49a12,12,0,0,1-17-17L163,76H88a12,12,0,0,1,0-24H192A12,12,0,0,1,204,64Z" }, null, -1)
      ]))) : l(r) === "duotone" ? (e(), o("g", H, t[1] || (t[1] = [
        n("path", {
          d: "M192,64V168L88,64Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M192,56H88a8,8,0,0,0-5.66,13.66L128.69,116,58.34,186.34a8,8,0,0,0,11.32,11.32L140,127.31l46.34,46.35A8,8,0,0,0,200,168V64A8,8,0,0,0,192,56Zm-8,92.69-38.34-38.34h0L107.31,72H184Z" }, null, -1)
      ]))) : l(r) === "fill" ? (e(), o("g", f, t[2] || (t[2] = [
        n("path", { d: "M200,64V168a8,8,0,0,1-13.66,5.66L140,127.31,69.66,197.66a8,8,0,0,1-11.32-11.32L128.69,116,82.34,69.66A8,8,0,0,1,88,56H192A8,8,0,0,1,200,64Z" }, null, -1)
      ]))) : l(r) === "light" ? (e(), o("g", h, t[3] || (t[3] = [
        n("path", { d: "M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z" }, null, -1)
      ]))) : l(r) === "regular" ? (e(), o("g", A, t[4] || (t[4] = [
        n("path", { d: "M200,64V168a8,8,0,0,1-16,0V83.31L69.66,197.66a8,8,0,0,1-11.32-11.32L172.69,72H88a8,8,0,0,1,0-16H192A8,8,0,0,1,200,64Z" }, null, -1)
      ]))) : l(r) === "thin" ? (e(), o("g", k, t[5] || (t[5] = [
        n("path", { d: "M196,64V168a4,4,0,0,1-8,0V73.66L66.83,194.83a4,4,0,0,1-5.66-5.66L182.34,68H88a4,4,0,0,1,0-8H192A4,4,0,0,1,196,64Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  M as default
};
